module.exports = __webpack_public_path__ + "static/media/thefarmers.b462b70f.png";